import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import THEME from '@maxpreps/shared/styles/colors';
import styled from 'styled-components';

export const StyledRecordCard = styled.div`
  display: grid;
  grid-template-columns: 100%;
  ${MediaQuery.Tablet} {
    grid-template-columns: 50% 50%;
  }
  padding: 20px 0;
`;

// Contains 2 summary boxes
export const StyledSummaryBoxContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 0 20px;
`;

// Pads StyledDetailsBoxContainer
export const StyledDetailsBoxContainerWrapper = styled.div`
  margin-top: 16px;
  ${MediaQuery.Tablet} {
    margin-top: 0;
  }
  padding: 0 20px;
`;

// Gray box containing 2 details boxes
export const StyledDetailsBoxContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 16px 0;
  background-color: ${THEME.surface.tertiary};
  border-radius: 8px;
`;
